import { ethers } from 'ethers';
import { ERC20_ABI, isNativeAddress, safeNormalize } from './swapUtils';

export async function getAllowanceStatus({ provider, tokenAddress, ownerAddress, spender, requiredAmount }) {
  const requiredBN = requiredAmount ? BigInt(requiredAmount) : BigInt(0);

  if (isNativeAddress(tokenAddress)) {
    return {
      tokenAddress,
      ownerAddress,
      spender,
      allowance: ethers.MaxUint256,
      allowanceRaw: ethers.MaxUint256.toString(),
      requiredAmountRaw: requiredBN.toString(),
      isUnlimited: true,
      isEnough: true
    };
  }

  const token = new ethers.Contract(safeNormalize(tokenAddress), ERC20_ABI, provider);
  const allowance = await token.allowance(safeNormalize(ownerAddress), safeNormalize(spender));
  return {
    tokenAddress: safeNormalize(tokenAddress),
    ownerAddress: safeNormalize(ownerAddress),
    spender: safeNormalize(spender),
    allowance,
    allowanceRaw: allowance.toString(),
    requiredAmountRaw: requiredBN.toString(),
    isUnlimited: allowance >= BigInt(ethers.MaxUint256 / BigInt(2)),
    isEnough: requiredBN === BigInt(0) || allowance >= BigInt(requiredBN)
  };
}
